import { render } from "./CaiDatGiaTriControl.vue?vue&type=template&id=5452ae24&ts=true"
import script from "./CaiDatGiaTriControl.vue?vue&type=script&lang=ts"
export * from "./CaiDatGiaTriControl.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__